import {loadScript} from "../methods/script-loader.js";
import Flickity from "flickity";

// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

// import window from "inputmask/lib/global/window";
const URL_YOUTUBE_API_LIB = "https://www.youtube.com/iframe_api",
    ID_FRAGMENT = "alpine-youtube-playlist",
    BREAKPOINTS = {
        "mobile": 0,
        "tablet": 768,
        "desktop": 990
    },
    RESPONSIVE_SLIDE_VISIBILITY_COUNT = {
        "mobile": 2,
        "tablet": 3,
        "desktop": 5
    },
    SELECTOR_CAROUSEL_ROOT = ".swiper";

let generateFakeSlides = false,
    extraSlides = 1;

// if there is more than one instance of the YouTube API, this will have to be abstracted into an extensible function (that will queue up things to be done on "onYouTubeIframeAPIReady")
window.onYouTubeIframeAPIReady = () => {
    // console.log( "onYouTubeIframeAPIReady", { arguments } );
    window.dispatchEvent( new CustomEvent( 'youtubeready', {
        detail: {
            message: 'YouTube iFrame API is ready for use'
        }
    }) );
};


const ResponsiveViews = [ "mobile", "tablet", "desktop" ]; // todo: refactor this to use BREAKPOINTS
function isMobile() {
    return window.matchMedia( `( max-width: ${ parseInt( BREAKPOINTS[ "tablet" ], 10 ) - 1 }px )` ).matches;
}
function isTablet() {
    return window.matchMedia( `( min-width: ${ parseInt( BREAKPOINTS[ "tablet" ], 10 ) }px ) and ( max-width: ${ parseInt( BREAKPOINTS[ "desktop" ], 10 ) - 1 }px )` ).matches;
}
function isDesktop() {
    return window.matchMedia( `( min-width: ${ parseInt( BREAKPOINTS[ "desktop" ], 10 ) }px )` ).matches;
}

// // Temporarily Boost the number of videos
if ( generateFakeSlides ) {

    let playlist = document.querySelector( ".youtube-playlist nav .swiper-wrapper" ),
        slide = playlist.querySelector( ".swiper-slide:last-child" ),
        maxIndex = slide.querySelector( "a" ).getAttribute( "data-index-ref" );
    for( let index= 0; index < extraSlides; index++ ) {
        ( () => {
            let clone = slide.cloneNode( true ),
                anchor = clone.querySelector( "a" ),
                newIndex = parseInt( maxIndex, 10 ) + parseInt( index, 10 ) + 1;
            anchor.setAttribute( "data-index-ref", newIndex );
            anchor.setAttribute( ":class", `{ 'active': currentIndex == ${ newIndex } }` );

            playlist.appendChild( clone );
        } )();
    }
}

export default () => ( {
    currentVideo: null,
    currentIndex: 0,
    cachedResponsiveView: ResponsiveViews[ 0 ], // default to Mobile
    Carousel: null,
    Player: null,
    DOMPlayerId: `${ ID_FRAGMENT }-${ Date.now() }`,
    DOMPlayerElement: null,
    isRegistered: false,
    PlayerAPIisReady: false,
    Videos: [],
    isCarousel: false,
    get disablePrevious() {
        if ( !this.Carousel ) { return true; }
        return this.Carousel.isBeginning;
    },
    get disableNext() {
        if ( !this.Carousel ) { return true; }
        return this.Carousel.isEnd;
    },
    get playerIsReady() {
        return this.PlayerAPIisReady && /* this.DataAPIisReady && */ this.Videos.length > 0;
    },
    getCarouselNecessary() {
        const videoCount = this.Videos.length;
        return ( isDesktop() && videoCount > 5 ) || ( isTablet() && videoCount > 3 ) || ( isMobile() && videoCount > 2 );
    },
    getResponsiveView() {
        if ( isDesktop() ) { return ResponsiveViews[ 2 ]; }
        if ( isTablet() ) { return ResponsiveViews[ 1 ]; }
        return ResponsiveViews[ 0 ]; // defaults to Mobile
    },
    onClickThumb( event ) {
        let index = event.target.closest( "[data-index-ref]" ).getAttribute( "data-index-ref" );
        this.currentIndex = index;
        this.$nextTick( () => {
            this.setPlayerVideo();
        } );
    },
    onClickPrevious( event ){
        if( !this.Carousel ){ return; }
        this.Carousel.slidePrev();
    },
    onClickNext( event ){
        if( !this.Carousel ){ return; }
        this.Carousel.slideNext();
    },
    retrievePlaylistVideos() {
        let items = [ ... this.$root.querySelectorAll( ".swiper-slide > a" ) ];

        this.Videos = items.map( ( item, index ) => {
            return {
                "videoId": item.getAttribute( "data-video-id" ),
                "index": item.getAttribute( "data-index-ref" ),
                "width": item.getAttribute( "data-width" ),
                "height": item.getAttribute( "data-height" )
            };
        } );

        this.$nextTick( () => {
            this.initPlayer();
            this.initCarousel();
        } );

    },
    initPlayer() {
        this.DOMPlayerElement.id = this.DOMPlayerId;
        this.currentIndex = 0;
        this.currentVideo = this.Videos[ this.currentIndex ];

        this.Player = new YT.Player(
            this.DOMPlayerId,
            {
                videoId: this.currentVideo.videoId,
                height: this.currentVideo.height,
                width: this.currentVideo.width,
                playerVars: {
                    controls: 1,
                    enablejsapi: 1,
                    playsinline: 1,
                    rel: 0,
                    autoplay: 0
                }
            } );

        this.setPlayerVideo();
    },
    buildCarousel() {
        this.isCarousel = true;

        let breakpointConfig = {};
        breakpointConfig[ BREAKPOINTS[ "tablet" ] ] = {
            slidesPerView: RESPONSIVE_SLIDE_VISIBILITY_COUNT[ "tablet" ],
        };
        breakpointConfig[ BREAKPOINTS[ "desktop" ] ] = {
            slidesPerView: RESPONSIVE_SLIDE_VISIBILITY_COUNT[ "desktop" ],
        };

        this.Carousel = new Swiper( this.$root.querySelector( SELECTOR_CAROUSEL_ROOT ), {
            preventClicks: true,
            slidesPerView: 2,
            spaceBetween: "20px",
            // centeredSlides: true,
            slideToClickedSlide: true,
            breakpoints: breakpointConfig
        } );

        this.Carousel.on( "destroy", ( event ) => {
            // console.log( "destroy!!!" );
            this.$nextTick( () => {
                this.Carousel = null;
            } );
        } );

        this.$nextTick( () => {
            window.app.Carousel = this.Carousel;
        } );

    },
    onResizeWindow( event ) {
        let self = this;

        let newResponsiveView = self.getResponsiveView();

        if ( newResponsiveView === self.cachedResponsiveView ) {
            // views are the same, bail.
            return;
        }

        // cache the new view
        self.cachedResponsiveView = newResponsiveView;

        // Conditionally build the Carousel
        self.conditionallyBuildCarousel();

    },
    conditionallyBuildCarousel(){
        let self = this,
            needCarousel = this.getCarouselNecessary();

        if ( !needCarousel ) {
            if ( !!self.Carousel ) {
                self.Carousel.destroy( true, true );
            }
            self.isCarousel = false;
            return;
        } else  {

            if ( !self.Carousel ) {
                self.$nextTick( () => {
                    self.buildCarousel();
                } );
            } else {
                self.$nextTick( () => {
                    self.Carousel.slideTo(parseInt( self.currentIndex, 10 ) + 1, 200 );
                } );
            }

        }
    },
    initCarousel() {
        let self = this;

        // Set resize listener that will dynamically init/destroy the carousel based on number of videos
        window.addEventListener( "resize", Alpine.debounce( self.onResizeWindow.bind( self ), 100 ) );

        self.conditionallyBuildCarousel();
    },
    onReadyYouTubeAPI( event ) {
        if ( !!!window.YT ) { return; }

        this.PlayerAPIisReady = true;
        this.$nextTick( () => {
            this.retrievePlaylistVideos();
        } );
    },
    setPlayerVideo() {
        if ( this.currentVideo === this.Videos[ this.currentIndex ] ) {
            return;
        }
        this.currentVideo = this.Videos[ this.currentIndex ];
        this.Player.cueVideoById( {
            "videoId": this.currentVideo.videoId
        } );
    },
    init() {
        let self = this;

        this.DOMPlayerElement = this.$root.querySelector( "figure div" );
        this.cachedResponsiveView = this.getResponsiveView();

        // iFrame API
        if (!window.YT) {
            loadScript( `${ URL_YOUTUBE_API_LIB }` );
            // YouTube manages its own readiness, so `loadScript`'s callback is nigh-meaningless
        } else {
            setTimeout( () => {
                self.onReadyYouTubeAPI();
            }, 200 );
        }

    }
} );
